var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu start-0"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" | "),(_vm.isAdmin)?_c('router-link',{attrs:{"to":"/admin"}},[_vm._v("Admin | ")]):_vm._e(),(_vm.isAdmin)?_c('router-link',{attrs:{"to":"/store"}},[_vm._v("Store | ")]):_vm._e(),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Login")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }